import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg"> & { strokeWidth?: number }

export const UrgentPriority = forwardRef<SVGSVGElement, Props>(
	({ strokeWidth = 1.2, ...props }, ref) => (
		<svg
			width="15"
			height="15"
			viewBox="0 0 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
			color={props.color ?? "#FB424C"}
		>
			<path
				d="M7.5 0.707107L14.2929 7.5L7.5 14.2929L0.707107 7.5L7.5 0.707107Z"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinejoin="round"
				fill="none"
			/>
			<path
				d="M7.5 2.82843L12.1716 7.5L7.5 12.1716L2.82843 7.5L7.5 2.82843Z"
				strokeLinejoin="round"
				fill="currentColor"
			/>
			<line
				x1="7.5"
				y1="5"
				x2="7.5"
				y2="8"
				stroke="white"
				strokeWidth={strokeWidth * 0.7}
				strokeLinecap="round"
			/>
			<circle cx="7.5" cy="9.5" r="0.5" fill="white" />
		</svg>
	),
)
